import slice from './slice';

export const { 
  resetState,

  setSerialNumber,
  setManualControl,
} = slice.actions;